import { styled, Link } from '@ori-ui/mui';
import { StaticNavigationNavigationItemDtoLinkType } from '@ori/static-api-client-react';
import React from 'react';

import { useFooterContext } from '../../hooks';
import { extractFooterNavigationType, extractChildrenWithNavigationType } from '../../utils';
import { ContentCaption } from './ContentCaption';
import { ContentRoot } from './ContentRoot';

const StyledLink = styled(Link)(({ theme }) => ({
  display: 'inline-block',
  margin: theme.spacing(1, 2),
  padding: theme.spacing(1, 0, 0, 0),
  textDecoration: 'underline',
}));

export const Content: React.FC = () => {
  const { data } = useFooterContext();

  const footer = extractFooterNavigationType(data);
  const bottom = extractChildrenWithNavigationType(StaticNavigationNavigationItemDtoLinkType.Bottom, footer);
  const copyright = extractChildrenWithNavigationType(
    StaticNavigationNavigationItemDtoLinkType.BottomCopyright,
    bottom,
  );

  const links = bottom?.children.filter((x) => x.linkType === StaticNavigationNavigationItemDtoLinkType.BottomLinks);

  return (
    <ContentRoot>
      <ContentCaption>{copyright?.title}</ContentCaption>
      <ContentCaption>
        {links
          ?.filter((link) => link.title)
          .map((link, index) => (
            <StyledLink
              key={link.title ?? index}
              href={link.url ?? ''}
              title={link.title ?? ''}
            >
              {link.title}
            </StyledLink>
          ))}
      </ContentCaption>
    </ContentRoot>
  );
};
